<template>
  <vx-card>
    <vs-popup fullscreen :title="'Add POI'" :active.sync="popupActive7">
      <vx-card style="z-index: 10000 !important">
        <vs-row>
          <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
            <input
              ref="pac"
              id="pac"
              v-model="pac"
              type="text"
              size="50"
              placeholder="Type and Enter to find places.."
            />
          </vs-col>
          <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="2">
            <vs-checkbox v-model="isCoordinates"
              >Find exact coordinates</vs-checkbox
            >
          </vs-col>
        </vs-row>
        <vs-input
          v-validate="'required|min:5'"
          data-vv-validate-on="blur"
          name="name"
          label-placeholder="POI Name"
          v-model="selectedPOI.name"
          class="w-full"
        />
        <br />
        <div
          v-if="
            userInfo.username == 'mhbadmin' ||
            userInfo.username == 'ironwatch' ||
            userInfo.username == 'demowatch'
          "
        >
          Type<v-select
            placeholder="Brand"
            :options="['PRODUCTIVE', 'UNPRODUCTIVE']"
            class="mb-4 md:mb-0"
            :clearable="false"
            v-model="selectedPOI.meta.type"
          />
          <br />
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="name"
            label-placeholder="POI Hex Color Code"
            v-model="selectedPOI.meta.color"
            class="w-full"
          />
        </div>
        <div
          v-if="
            userInfo.username == 'igtmaldives' ||
            userInfo.username == 'maldives' ||
            userInfo.username == 'pmluser'
          "
        >
          <br />
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="name"
            label-placeholder="POI Hex Color Code"
            v-model="selectedPOI.meta.color"
            class="w-full"
          />
          <br />
          <vs-input
            label-placeholder="Ammend Date"
            v-model="selectedPOI.meta.ammendDate"
            class="w-full"
          />
          <br />
          <vs-input
            label-placeholder="Ammended Decree"
            v-model="selectedPOI.meta.ammendedDecree"
            class="w-full"
          />
          <br />
          <vs-input
            label-placeholder="Atoll"
            v-model="selectedPOI.meta.atoll"
            class="w-full"
          />
          <br />
          <vs-input
            label-placeholder="Category"
            v-model="selectedPOI.meta.category"
            class="w-full"
          />
          <br />
          <vs-input
            label-placeholder="Declared Date"
            v-model="selectedPOI.meta.declaredDate"
            class="w-full"
          />
          <br />
          <vs-input
            label-placeholder="Type"
            v-model="selectedPOI.meta.type"
            class="w-full"
          />
          <br />
          <vs-input
            label-placeholder="Decree Of Protection"
            v-model="selectedPOI.meta.decreeOfProtection"
            class="w-full"
          />
          <br />
        </div>
        <br />

        <vs-row>
          <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="2">
            <vs-button
              color="success"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              size="small"
              @click="addPOI2"
              >Add New POI</vs-button
            >
          </vs-col>
          <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="2">
            <vs-button
              color="success"
              type="filled"
              icon-pack="feather"
              icon="icon-edit"
              size="small"
              @click="startDrawing"
              >Start Drawing</vs-button
            >
          </vs-col>
          <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="2">
            <vs-button
              color="warning"
              type="filled"
              icon-pack="feather"
              icon="icon-pause"
              size="small"
              @click="stopDrawing"
              >Stop Drawing</vs-button
            >
          </vs-col>
          <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="2">
            <vs-button
              color="danger"
              type="filled"
              icon-pack="feather"
              icon="icon-trash"
              size="small"
              @click="removeDrawing"
              >Remove All Drawing</vs-button
            >
          </vs-col>
        </vs-row>
        <br />
        <div id="map2" ref="map2"></div>
      </vx-card>
    </vs-popup>

    <vs-popup fullscreen :title="'Manage POI'" :active.sync="popupActive8">
      <vx-card>
        <vs-row>
          <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
            <input
              ref="pac2"
              id="pac2"
              v-model="pac"
              type="text"
              size="50"
              placeholder="Type and Enter to find places.."
            />
          </vs-col>
          <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="2">
            <vs-checkbox v-model="isCoordinates"
              >Find exact coordinates</vs-checkbox
            >
          </vs-col>
        </vs-row>
        <br />
        <vs-input
          v-validate="'required|min:5'"
          data-vv-validate-on="blur"
          name="name"
          label-placeholder="POI Name"
          v-model="selectedPOI.name"
          class="w-full"
        />
        <div
          v-if="
            userInfo.username == 'mhbadmin' ||
            userInfo.username == 'ironwatch' ||
            userInfo.username == 'demowatch'
          "
        >
          Type<v-select
            placeholder="Brand"
            :options="['PRODUCTIVE', 'UNPRODUCTIVE']"
            class="mb-4 md:mb-0"
            :clearable="false"
            v-model="selectedPOI.meta.type"
          />
          <br />
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="name"
            label-placeholder="POI Hex Color Code"
            v-model="selectedPOI.meta.color"
            class="w-full"
          />
        </div>
        <div
          v-if="
            userInfo.username == 'igtmaldives' ||
            userInfo.username == 'maldives' ||
            userInfo.username == 'pmluser'
          "
        >
          <br />
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="name"
            label-placeholder="POI Hex Color Code"
            v-model="selectedPOI.meta.color"
            class="w-full"
          />
          <br />
          <vs-input
            label-placeholder="Ammend Date"
            v-model="selectedPOI.meta.ammendDate"
            class="w-full"
          />
          <br />
          <vs-input
            label-placeholder="Ammended Decree"
            v-model="selectedPOI.meta.ammendedDecree"
            class="w-full"
          />
          <br />
          <vs-input
            label-placeholder="Atoll"
            v-model="selectedPOI.meta.atoll"
            class="w-full"
          />
          <br />
          <vs-input
            label-placeholder="Category"
            v-model="selectedPOI.meta.category"
            class="w-full"
          />
          <br />
          <vs-input
            label-placeholder="Declared Date"
            v-model="selectedPOI.meta.declaredDate"
            class="w-full"
          />
          <br />
          <vs-input
            label-placeholder="Type"
            v-model="selectedPOI.meta.type"
            class="w-full"
          />
          <br />
          <vs-input
            label-placeholder="Decree Of Protection"
            v-model="selectedPOI.meta.decreeOfProtection"
            class="w-full"
          />
          <br />
        </div>
        <br />

        <br />
        <vs-row>
          <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="2">
            <vs-button
              color="success"
              type="filled"
              icon-pack="feather"
              icon="icon-edit"
              size="small"
              @click="startDrawing"
              >Start Drawing</vs-button
            >
          </vs-col>
          <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="2">
            <vs-button
              color="warning"
              type="filled"
              icon-pack="feather"
              icon="icon-pause"
              size="small"
              @click="stopDrawing"
              >Stop Drawing</vs-button
            >
          </vs-col>
          <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="2">
            <vs-button
              color="danger"
              type="filled"
              icon-pack="feather"
              icon="icon-trash"
              size="small"
              @click="removeDrawing2"
              >Remove All Drawing</vs-button
            >
          </vs-col>
          <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="2">
            <vs-button
              color="success"
              type="filled"
              icon-pack="feather"
              icon="icon-edit"
              size="small"
              @click="updatePOI"
              v-if="userInfo.access.actions.includes('poi-delete')"
              >Update POI</vs-button
            >
          </vs-col>
          <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="2">
            <vs-button
              color="danger"
              type="filled"
              icon-pack="feather"
              icon="icon-trash"
              size="small"
              @click="deletePOI"
              v-if="userInfo.access.actions.includes('poi-delete')"
              >Delete POI</vs-button
            >
          </vs-col>
        </vs-row>
        <br />
        <div id="map" ref="map"></div>
        <br />
      </vx-card>
    </vs-popup>

    <vs-progress
      indeterminate
      color="primary"
      v-if="isLoading == true"
    ></vs-progress>

    <vs-button
      size="small"
      @click="addPOI"
      v-if="userInfo.access.actions.includes('poi-add')"
      >Add New POI</vs-button
    ><br />
    <ejs-grid
      :dataSource="poiData"
      :allowExcelExport="true"
      @excelQueryCellInfo="exportHandler"
      @pdfQueryCellInfo="exportHandler"
      :allowPdfExport="true"
      :toolbarClick="toolbarClick4"
      :allowTextWrap="true"
      height="60vh"
      gridLines="Both"
      :filterSettings="filterOptions"
      :allowPaging="true"
      :searchSettings="searchOptions2"
      :toolbar="toolbarOptions"
      ref="userPOIGrid"
      id="userPOIGrid"
      :pageSettings="pageSettings"
      :showColumnChooser="true"
      :allowSorting="true"
      :allowMultiSorting="true"
      :allowFiltering="true"
    >
      <e-columns>
        <e-column field="name" headerText="Name" textAlign="Left"></e-column>
        <e-column
          field="address"
          headerText="Address"
          textAlign="Left"
        ></e-column>
        <e-column
          headerText="Coordinates"
          field="coordinates"
          textAlign="Left"
          :template="cTemplate"
        ></e-column>
        <e-column
          headerText="Manage"
          textAlign="Left"
          :template="cTemplate4"
        ></e-column>
      </e-columns>
    </ejs-grid>
  </vx-card>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader';
import {
  GridPlugin,
  Sort,
  Group,
  Filter,
  Toolbar,
  Resize,
  Search,
  ExcelExport,
  ColumnChooser,
  PdfExport,
  Page,
  CommandColumn,
} from '@syncfusion/ej2-vue-grids';
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns';
import columntempVue4 from './editButtonTemplate4.vue';
import columntempVue from './reportLinkTemplate1.vue';
import vSelect from 'vue-select';

export default {
  components: {
    GridPlugin,
    vSelect,
    MultiSelectPlugin,
    columntempVue4,
    columntempVue,
  },
  provide: {
    grid: [
      Group,
      Sort,
      Filter,
      Toolbar,
      Search,
      Resize,
      ExcelExport,
      ColumnChooser,
      PdfExport,
      Page,
      CommandColumn,
    ],
  },
  data() {
    return {
      isCoordinates: false,
      pac: null,
      webMapLocal: localStorage.getItem('webmap-poiview-maptype') || 'roadmap',
      webMapShowPOILocal:
        localStorage.getItem('webmap-poiview-showpoi') || true,
      poiReferences: [],
      groups: [],
      unitSelection: JSON.parse(localStorage.getItem('unitSelection')),
      mapPOIData: JSON.parse(localStorage.getItem('mapPOIData')),
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      alarmData: [],
      unitData2: [],
      refreshKey: 0,
      filteredGroup: {},
      isLoading: false,
      toolbarOptions: ['Search', 'ExcelExport', 'PdfExport', 'ColumnChooser'],
      unitData: [],
      userData: [],
      groupData: [],
      poiData: [],
      fields1: { text: 'name', value: 'id' },
      fields2: { text: 'name', value: 'id' },
      fields3: { text: 'username', value: 'id' },
      fields4: { text: 'name', value: 'id' },
      fields5: { groupBy: 'assetGroup', text: 'assetName', value: 'assetId' },
      searchOptions: {
        fields: ['name', 'unitId', 'model', 'cellular'],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      searchOptions2: {
        fields: [
          'name',
          'username',
          'password',
          'company',
          'phone',
          'email',
          'createdBy',
        ],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      searchOptions3: {
        fields: ['name'],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      searchOptions4: {
        fields: ['type', 'reference'],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      filterOptions: { type: 'Menu' },
      pageSettings: { pageSizes: [10, 50, 100, 300, 'All'], pageSize: 10 },
      selectedUnit: {},
      unitMetadataRefined: {},
      popupActive: false,
      popupActive3: false,
      popupActive4: false,
      popupActive5: false,
      popupActive9: false,
      popupActive6: false,
      popupActive7: false,
      popupActive8: false,
      popupActive10: false,
      popupActive11: false,
      selectedUser: {},
      loader: null,
      map: null,
      gmarkers: [],
      selectedPOI: {
        overlays: [],
        currPolygon: null,
        push_notification: 'false',
        id: null,
        draw: null,
        drawingManager: null,
        coords: [[]],
        alternateCoords: [],
        centerLat: '',
        centerLng: '',
        name: '',
        type: '',
        alert: '',
        meta: {
          type: '',
          color: '',
        },
      },
      userMetadataRefined: {},
      selectedGroup: {},
      popupActive2: false,
      cTemplate() {
        return { template: columntempVue };
      },
      cTemplate4() {
        return { template: columntempVue4 };
      },
    };
  },
  watch: {},
  methods: {
    exportHandler(args) {
      if (args.column.field === 'coordinates') {
        args.value = args.data.centerLat + ',' + args.data.centerLng;
      }
    },
    toolbarClick4(args) {
      if (args.item.id === 'userPOIGrid_excelexport') {
        var exportProperties = {
          fileName: 'POI - Listing.xlsx',
        };
        if (this.$refs.userPOIGrid) {
          this.$refs.userPOIGrid.excelExport(exportProperties);
        }
      }
      if (args.item.id === 'userPOIGrid_pdfexport') {
        var exportProperties = {
          pageOrientation: 'Potrait',
          fileName: 'POI - Listing.pdf',
        };
        this.$refs.userPOIGrid.pdfExport(exportProperties);
      }
    },
    editPOI(preSelectedPOI) {
      try {
        const self = this;
        let selectedPOI = preSelectedPOI;

        if (selectedPOI.meta != null) {
          if (typeof selectedPOI.meta === 'string') {
            selectedPOI.meta = JSON.parse(selectedPOI.meta);
          }
        }

        if (selectedPOI.meta == null) {
          selectedPOI.meta = {
            type: '',
            color: '',
          };
        }
        self.selectedPOI = selectedPOI;
        self.selectedPOI.updatedPOI = {
          coords: [[]],
          alternateCoords: [],
          currPolygon: null,
          centerLat: '',
          centerLng: '',
        };
        self.popupActive8 = true;

        self.loader = new Loader(this.$loader);

        self.loader.load().then(() => {
          self.map = new google.maps.Map(self.$refs.map, {
            center: { lat: selectedPOI.centerLat, lng: selectedPOI.centerLng },
            zoom: 18,
            mapTypeId: self.webMapLocal,
            gestureHandling: 'greedy',
          });
          let baseColor = '#BF40BF';
          if (self.selectedPOI.meta.color) {
            baseColor = self.selectedPOI.meta.color;
          }
          const poi = new google.maps.Polygon({
            paths:
              typeof selectedPOI.alternateCoords === 'string'
                ? JSON.parse(selectedPOI.alternateCoords)
                : selectedPOI.alternateCoords,
            fillColor: baseColor,
            fillOpacity: 0.6,
            strokeWeight: 2,
            metadata: {
              name: selectedPOI.name,
              lat: selectedPOI.centerLat,
              lng: selectedPOI.centerLng,
            },
          });

          poi.setMap(self.map);

          const searchBox = new google.maps.places.SearchBox(self.$refs.pac2);
          self.selectedPOI.drawingManager =
            new google.maps.drawing.DrawingManager({
              drawingControl: false,
              drawingControlOptions: {
                position: google.maps.ControlPosition.TOP_CENTER,
                drawingModes: [google.maps.drawing.OverlayType.POLYGON],
              },

              polygonOptions: {
                fillColor: '#ffb6c1',
                fillOpacity: 0.6,
                strokeWeight: 2,
              },
            });

          self.selectedPOI.drawingManager.setMap(self.map);
          new google.maps.event.addListener(
            self.selectedPOI.drawingManager,
            'polygoncomplete',
            function (polygon) {
              let i = 0;
              if (self.selectedPOI.updatedPOI.currPolygon != null) {
                self.selectedPOI.updatedPOI.currPolygon.setMap(null);
                self.selectedPOI.updatedPOI.currPolygon = null;
                self.selectedPOI.updatedPOI.coords = [[]];
                self.selectedPOI.updatedPOI.alternateCoords = [];
                self.selectedPOI.updatedPOI.centerLat = '';
                self.selectedPOI.updatedPOI.centerLng = '';
                self.selectedPOI.updatedPOI.overlays = [];
              }

              for (i = 0; i < polygon.getPath().getLength(); i++) {
                self.selectedPOI.updatedPOI.coords[0].push([
                  polygon.getPath().getAt(i).lng(),
                  polygon.getPath().getAt(i).lat(),
                ]);
                self.selectedPOI.updatedPOI.alternateCoords.push({
                  lat: polygon.getPath().getAt(i).lat(),
                  lng: polygon.getPath().getAt(i).lng(),
                });
              }
              if (i == polygon.getPath().getLength()) {
                self.selectedPOI.updatedPOI.currPolygon = polygon;
                return self.$vs.notify({
                  title: 'Valid polygon drawn',
                  text: 'Fill up other details and click submit',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'primary',
                });
              }
            },
          );

          searchBox.addListener('places_changed', () => {
            self.removeMarkers();
            if (self.isCoordinates == true) {
              let pacArray = self.pac.split(',');
              const lat = Number(pacArray[0]);
              const lng = Number(pacArray[1]);
              const marker = new google.maps.Marker({
                position: { lat, lng },
                label: {
                  text: 'Coordinates search',
                  color: 'black',
                  fontSize: '16px',
                  align: 'center',
                  fontWeight: 'bold',
                },
                icon: {
                  path: google.maps.SymbolPath.CIRCLE,
                  scale: 8,
                  strokeWeight: 3,
                },
                map: self.map,
              });
              self.gmarkers.push(marker);
              self.map.panTo({
                lat: lat,
                lng: lng,
              });
            } else {
              const places = searchBox.getPlaces();

              if (places.length == 0) {
                return;
              }

              // For each place, get the icon, name and location.
              const bounds = new google.maps.LatLngBounds();
              places.forEach((place) => {
                if (!place.geometry || !place.geometry.location) {
                  console.log('Returned place contains no geometry');
                  return;
                }

                // Create a marker for each place.

                if (place.geometry.viewport) {
                  // Only geocodes have viewport.
                  bounds.union(place.geometry.viewport);
                } else {
                  bounds.extend(place.geometry.location);
                }
                const lat = place.geometry.location.lat();
                const lng = place.geometry.location.lng();
                const marker = new google.maps.Marker({
                  position: { lat, lng },
                  label: {
                    text: place.formatted_address,
                    color: 'black',
                    fontSize: '16px',
                    align: 'center',
                    fontWeight: 'bold',
                  },
                  icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 8,
                    strokeWeight: 3,
                  },
                  map: self.map,
                });
                self.gmarkers.push(marker);
              });
              self.map.fitBounds(bounds);
            }
          });

          if (
            self.userInfo.username == 'mhbadmin' ||
            self.userInfo.username == 'ironwatch' ||
            userInfo.username == 'demowatch'
          ) {
            const poi = self.mapPOIData.map((data, i) => {
              const poi = new google.maps.Polygon(data);
              self.poiReferences.push(poi);
              google.maps.event.addListener(poi, 'click', function (event) {
                alert(data.metadata.name);
              });
              poi.setMap(self.map);

              return poi;
            });
          }
        });
      } catch (e) {
        console.log(e);
      }
    },

    addPOI() {
      var self = this;
      self.selectedPOI = {
        currPolygon: null,
        loader: null,
        map: null,
        draw: null,
        drawingManager: null,
        coords: [[]],
        alternateCoords: [],
        centerLat: '',
        centerLng: '',
        name: '',
        type: '',
        alert: '',
        meta: {
          type: 'PRODUCTIVE',
          color: '',
        },
      };
      self.popupActive7 = true;
      var self = this;
      self.loader = new Loader(this.$loader);

      self.loader.load().then(() => {
        let center = { lat: 2.9775249, lng: 101.44862365 };

        if (
          self.userInfo.username == 'maldives' ||
          self.userInfo.username == 'igtmaldives' ||
          self.userInfo.username == 'pmluser'
        ) {
          center = { lat: 3.1098336, lng: 67.9419532 };
        }
        self.map = new google.maps.Map(self.$refs.map2, {
          center: center,
          zoom: 8,
          mapTypeId: self.webMapLocal,
          gestureHandling: 'greedy',
        });

        const searchBox = new google.maps.places.SearchBox(self.$refs.pac);
        self.selectedPOI.drawingManager =
          new google.maps.drawing.DrawingManager({
            drawingControl: false,
            drawingControlOptions: {
              position: google.maps.ControlPosition.TOP_CENTER,
              drawingModes: [google.maps.drawing.OverlayType.POLYGON],
            },

            polygonOptions: {
              fillColor: '#ffb6c1',
              fillOpacity: 0.6,
              strokeWeight: 2,
            },
          });
        self.selectedPOI.drawingManager.setMap(self.map);

        new google.maps.event.addListener(
          self.selectedPOI.drawingManager,
          'polygoncomplete',
          function (polygon) {
            let i = 0;
            if (self.selectedPOI.currPolygon != null) {
              self.selectedPOI.currPolygon.setMap(null);
              self.selectedPOI.currPolygon = null;
              self.selectedPOI.coords = [[]];
              self.selectedPOI.alternateCoords = [];
              self.selectedPOI.centerLat = '';
              self.selectedPOI.centerLng = '';
              self.selectedPOI.overlays = [];
            }

            for (i = 0; i < polygon.getPath().getLength(); i++) {
              self.selectedPOI.coords[0].push([
                polygon.getPath().getAt(i).lng(),
                polygon.getPath().getAt(i).lat(),
              ]);
              self.selectedPOI.alternateCoords.push({
                lat: polygon.getPath().getAt(i).lat(),
                lng: polygon.getPath().getAt(i).lng(),
              });
            }
            if (i == polygon.getPath().getLength()) {
              self.selectedPOI.currPolygon = polygon;
              return self.$vs.notify({
                title: 'Valid polygon drawn',
                text: 'Fill up other details and click submit',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'primary',
              });
            }
          },
        );

        searchBox.addListener('places_changed', () => {
          self.removeMarkers();
          if (self.isCoordinates == true) {
            let pacArray = self.pac.split(',');
            const lat = Number(pacArray[0]);
            const lng = Number(pacArray[1]);
            const marker = new google.maps.Marker({
              position: { lat, lng },
              label: {
                text: 'Coordinates search',
                color: 'black',
                fontSize: '16px',
                align: 'center',
                fontWeight: 'bold',
              },
              icon: {
                path: google.maps.SymbolPath.CIRCLE,
                scale: 8,
                strokeWeight: 3,
              },
              map: self.map,
            });
            self.gmarkers.push(marker);
            self.map.panTo({
              lat: lat,
              lng: lng,
            });
          } else {
            const places = searchBox.getPlaces();

            if (places.length == 0) {
              return;
            }

            // For each place, get the icon, name and location.
            const bounds = new google.maps.LatLngBounds();
            places.forEach((place) => {
              if (!place.geometry || !place.geometry.location) {
                console.log('Returned place contains no geometry');
                return;
              }

              // Create a marker for each place.

              if (place.geometry.viewport) {
                // Only geocodes have viewport.
                bounds.union(place.geometry.viewport);
              } else {
                bounds.extend(place.geometry.location);
              }
              const lat = place.geometry.location.lat();
              const lng = place.geometry.location.lng();
              const marker = new google.maps.Marker({
                position: { lat, lng },
                label: {
                  text: place.formatted_address,
                  color: 'black',
                  fontSize: '16px',
                  align: 'center',
                  fontWeight: 'bold',
                },
                icon: {
                  path: google.maps.SymbolPath.CIRCLE,
                  scale: 8,
                  strokeWeight: 3,
                },
                map: self.map,
              });
              self.gmarkers.push(marker);
            });
            self.map.fitBounds(bounds);
          }
        });

        if (
          self.userInfo.username == 'mhbadmin' ||
          self.userInfo.username == 'ironwatch' ||
          self.userInfo.username == 'demowatch'
        ) {
          const poi = self.mapPOIData.map((data, i) => {
            const poi = new google.maps.Polygon(data);
            self.poiReferences.push(poi);
            google.maps.event.addListener(poi, 'click', function (event) {
              alert(data.metadata.name);
            });
            poi.setMap(self.map);

            return poi;
          });
        }
      });
    },
    removeMarkers() {
      const self = this;
      if (self.gmarkers.length != 0) {
        for (let i = 0; i < self.gmarkers.length; i++) {
          self.gmarkers[i].setMap(null);
        }
      }
    },
    reset() {
      const self = this;
      self.removeMarkers();
      self.map.panTo({
        lat: 2.9775249,
        lng: 101.44862365,
      });
      self.map.setZoom(8);
    },
    addPOI2() {
      const self = this;
      if (
        self.selectedPOI.coords == null ||
        self.selectedPOI.name == '' ||
        self.selectedPOI.alternateCoords.length < 3
      ) {
        return self.$vs.notify({
          title: 'Error',
          text: 'Draw polygon & fill up POI details before submit',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
      }
      self.selectedPOI.coords[0].push(self.selectedPOI.coords[0][0]);
      // console.log({
      //   coords: self.selectedPOI.coords,
      //   alternateCoords: self.selectedPOI.alternateCoords,
      //   name: self.selectedPOI.name,
      //   groups: self.groups,
      //   uid: self.userInfo.uid,
      //   meta: self.selectedPOI.meta,
      // });
      self.$http
        .post('settings/poi', {
          coords: self.selectedPOI.coords,
          alternateCoords: self.selectedPOI.alternateCoords,
          name: self.selectedPOI.name,
          groups: self.groups,
          uid: self.userInfo.uid,
          meta: self.selectedPOI.meta,
        })
        .then(function (response) {
          // console.log(response);
          self.popupActive7 = false;
          self.getData();
          self.selectedPOI = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Addded new POI. You can set alerts by clicking manage button!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not add POI.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not add POI.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not add POI.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    updatePOI() {
      const self = this;
      if (self.selectedPOI.name == '') {
        return self.$vs.notify({
          title: 'Error',
          text: 'Draw polygon & fill up POI details before submit',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
      }
      let type = 0;
      if (self.selectedPOI.updatedPOI.currPolygon != null) {
        type = 1;
        self.selectedPOI.updatedPOI.coords[0].push(
          self.selectedPOI.updatedPOI.coords[0][0],
        );
      }

      self.selectedPOI.drawingManager = null;
      self.selectedPOI.updatedPOI.currPolygon = null;
      //console.log(self.selectedPOI)
      self.$http
        .patch('settings/poi', {
          selectedPOI: self.selectedPOI,
          type,
          groups: self.groups,
          uid: self.userInfo.uid,
          meta: self.selectedPOI.meta,
        })
        .then(function (response) {
          self.popupActive8 = false;
          self.getData();
          self.selectedPOI = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Updated POI. You can set alerts by clicking manage button!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not update POI.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not update POI.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          // console.log(error)
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not update POI.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    deletePOI() {
      const self = this;
      if (self.selectedPOI.id) {
        return self.$vs.notify({
          title: 'Error',
          text: 'Could not delete POI because of existing alerts subscription. Delete the alert before deleting the POI.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
      }
      self.$http
        .delete(`admin/pois/${self.selectedPOI.poiId}`, {})
        .then(function (response) {
          self.popupActive8 = false;
          self.getData();
          self.selectedPOI = {
            loader: null,
            map: null,
            draw: null,
            drawingManager: null,
            coords: [[]],
            alternateCoords: [],
            centerLat: '',
            centerLng: '',
            name: '',
            type: '',
            alert: '',
            meta: {
              type: '',
              color: '',
            },
          };
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Deleted POI records.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not delete POI.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not delete POI.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not delete POI.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    getData() {
      const self = this;
      self.$http
        .get(`settings/poi/${self.userInfo.uid}`, {})
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.poiData = response.data.poiData;
            self.groups = response.data.groups;
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {});
    },
    startDrawing() {
      this.selectedPOI.drawingManager.setDrawingMode(
        google.maps.drawing.OverlayType.POLYGON,
      );
    },
    removeDrawing() {
      const self = this;
      self.selectedPOI.coords = [[]];
      self.selectedPOI.alternateCoords = [];
      self.selectedPOI.centerLat = '';
      self.selectedPOI.centerLng = '';
      self.selectedPOI.drawingManager.setDrawingMode(null);
      self.$vs.notify({
        title: 'Success',
        text: 'Reset all POI drawings',
        color: 'warning',
      });
      self.selectedPOI.overlays = [];
      if (self.selectedPOI.currPolygon != null) {
        self.selectedPOI.currPolygon.setMap(null);
        self.selectedPOI.currPolygon = null;
      }
    },
    removeDrawing2() {
      const self = this;
      self.selectedPOI.updatedPOI.coords = [[]];
      self.selectedPOI.updatedPOI.alternateCoords = [];
      self.selectedPOI.updatedPOI.centerLat = '';
      self.selectedPOI.updatedPOI.centerLng = '';
      self.selectedPOI.drawingManager.setDrawingMode(null);
      self.$vs.notify({
        title: 'Success',
        text: 'Reset all POI drawings',
        color: 'warning',
      });
      self.selectedPOI.updatedPOI.overlays = [];
      if (self.selectedPOI.updatedPOI.currPolygon != null) {
        self.selectedPOI.updatedPOI.currPolygon.setMap(null);
        self.selectedPOI.updatedPOI.currPolygon = null;
      }
    },
    stopDrawing() {
      this.selectedPOI.drawingManager.setDrawingMode(null);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style>
.e-grid .e-excelexport {
  color: green;
  font-weight: bold;
}

.e-grid .e-pdfexport {
  color: red;
  font-weight: bold;
}

#map {
  height: 80vh;
}

#map2 {
  height: 80vh;
}

@import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css';
</style>
